export const offers = 'offers';
export const optionFibreInternet15G = 'Fibre Internet 1.5G';
export const tenInternetBundleDiscount = '$10 Internet Bundle Discount';
export const seventyInternet3pPlusDiscount = '$70 Internet 3P+ Discount';
export const hundredBillCreditOnHSIA = '$200 Bill Credit on HSIA';

export const pricingFields = [offers];
